import {
  type OverrideConfig,
  getSubDomain,
  getDomain,
  getTld,
  getPathPrefix,
} from './internal/pure-url-utils';

/**
 * Enviro-less version of getFullUrl
 */
export function getFullUrlPure(
  subDomainPrefix: string,
  hublet: string,
  environment: 'prod' | 'qa',
  overrideConfig?: OverrideConfig
): string {
  const subDomain = getSubDomain(hublet, subDomainPrefix, overrideConfig);
  const domain = getDomain(hublet, environment, overrideConfig);
  const tld = getTld(overrideConfig);
  const pathPrefix = getPathPrefix(subDomainPrefix);

  return `https://${subDomain}.${domain}.${tld}${pathPrefix}`;
}

export { OverrideConfig };
